<template>
  <header class="title" :class="`${type}-image`">
    <h3>
      {{ title }}
    </h3>
  </header>
</template>
<script>
export default {
  name: 'MobileSectionHeader',
  props: {
    title: {
      type: String,
      required: true
    },
    type: String
  },
  comments: true
}
</script>
<style scoped lang="sass">
/* purgecss start ignore */
@tailwind utilities

.title
  @apply flex items-center justify-center text-transparent text-4xl text-center uppercase font-bold h-full px-2
  -webkit-text-stroke-width: 1px
  -webkit-text-stroke-color: #FFFFFF
  background-size: cover
  background-repeat: no-repeat

.creativity-image
  background-image: url("~@/assets/images/sections/varios-passaros-origami-alinhados.jpg")

.solutions-image
  background-image: url("~@/assets/images/sections/varios-origamis-dentro-de-recipiente.jpg")

.bio-image
  background-image: url("~@/assets/images/sections/mulher-segurando-origami-de-coelho.jpg")
/* purgecss end ignore */
</style>
